// extracted by mini-css-extract-plugin
export default {"tr":"TranslationsTableRow_tr__DZvXG","arabic":"TranslationsTableRow_arabic__djzih"};